export enum ActionType {
  Eventualities = 1,
  PushNotifications = 2,
  PaymentMethods = 3,
  GlobalOffers = 4,
  Verticals = 5,
  RedButton = 6
}
